module.exports = __webpack_public_path__ + "static/internet-newtelecom-9ec64e2d3b4858941ddd1161ec080b69.jpg";